import classNames from 'classnames'
import { ElCard } from 'element-plus'
import type { FunctionalComponent } from 'vue'
import './HocElCard.scss'

type ElCardProps = InstanceType<typeof ElCard>['$props']

export const HocElCard: FunctionalComponent<ElCardProps> = (_props, { slots, attrs }) => {
  return (
    <ElCard {...attrs} class={classNames('hoc-el-card', attrs.class as string)}>
      {slots}
    </ElCard>
  )
}
HocElCard.inheritAttrs = false
